import * as React from 'react';
import * as styles from './styles.css';
import { UIText1 } from '@cian/ui-kit';

export interface IPartner {
  photo: string;
  name: string;
  experience: string;
  description: string;
}

export interface IPartnersSectionProps {
  partners: IPartner[];
  rootRef: React.Ref<HTMLDivElement>;
  trackRef: React.Ref<HTMLDivElement>;
  prevButtonRef: React.Ref<HTMLButtonElement>;
  nextButtonRef: React.Ref<HTMLButtonElement>;
  onPrevClick: () => void;
  onNextClick: () => void;
  onCtaClick: () => void;
  prevArrowIcon: string;
}

export const PartnersSection: React.FC<IPartnersSectionProps> = ({
  partners,
  rootRef,
  trackRef,
  prevButtonRef,
  nextButtonRef,
  onPrevClick,
  onNextClick,
  onCtaClick,
  prevArrowIcon,
}) => (
  <section className={`${styles['partners-section']} reveal`} aria-label="Наши партнёры">
    <div className={styles['partners']}>
      <div className={styles['partners__header']}>
        <h2 className={`${styles['partners__title']} text-primary`}>Наши партнёры</h2>
        <div className={styles['partners__controls']} aria-label="Листать карточки партнёров">
          <button
            ref={prevButtonRef}
            className={`${styles['partners__arrow']} ${styles['partners__arrow--prev']}`}
            type="button"
            onClick={onPrevClick}
            data-partners-prev
            aria-label="Назад"
          >
            <img src={prevArrowIcon} alt="" />
          </button>
          <button
            ref={nextButtonRef}
            className={styles['partners__arrow']}
            type="button"
            onClick={onNextClick}
            data-partners-next
            aria-label="Вперёд"
          >
            <img src={prevArrowIcon} alt="" />
          </button>
        </div>
      </div>
      <div ref={rootRef} className={styles['partners-slider']} data-partners-slider>
        <div ref={trackRef} className={styles['partners-slider__track']} data-partners-track>
          {partners.map(partner => (
            <article key={partner.name} className={styles['partner-card']}>
              <div className={styles['partner-card__photo']}>
                <img src={partner.photo} alt={partner.name} />
              </div>
              <div className={styles['partner-card__body']}>
                <div className={styles['partner-card__title-row']}>
                  <h4 className="text-primary">{partner.name}</h4>
                  <span className={`${styles['pricing-card__label']} body2`}>{partner.experience}</span>
                </div>
                <p className={`${styles['partner-card__text']} body1 text-secondary`}>{partner.description}</p>
              </div>
            </article>
          ))}
          <article className={`${styles['partner-card']} ${styles['partner-card--cta']}`}>
            <div className={`${styles['partner-card__body']} ${styles['partner-card__body--center']}`}>
              <h3 className={styles['partner-card__title']}>
                50+
                <br />
                риелторов
                <br />
                уже с нами
              </h3>
              <UIText1 color="text-primary-default">
                Подберём профи
                <br />
                под любой запрос
              </UIText1>
              <button
                className={`${styles['btn']} ${styles['btn--primary']}`}
                type="button"
                onClick={onCtaClick}
                data-modal-open
              >
                <span className={styles['btn__text']}>Оставить заявку</span>
              </button>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
);
